import { Navigate, Outlet } from 'react-router-dom';
import { useTenant } from './TenantContext';

/**
 * Route guard that redirects to the Tenant Picker when no tenant is selected.
 * Wraps all routes that require an active tenant context.
 */
export default function TenantGuard() {
  const { tenant } = useTenant();

  if (!tenant) {
    return <Navigate to="/select-mailbox" replace />;
  }

  return <Outlet />;
}
